import Styleguide, { Colors } from "../../theme";
import styled from "styled-components";

export const ComponentProvider = styled.button`
  display: flex;
  align-content: center;
  justify-content: center;
  width: 140px;
  height: 88px;
  padding: 0px 16px;
  cursor: pointer;
  outline: none;
  border: none;
  border-radius: 8px;
  background-color: ${Colors.gray[400]};
  opacity: 0;
  transform: scale(0.5);
  animation: zoomIn 0.5s ease forwards;

  @keyframes zoomIn {
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  &:hover {
    background-color: ${Colors.white};
  }

  &:focus,
  &:active {
    outline: 2px solid ${Colors.lightBlue[100]};
    outline-offset: 3px;
    background-color: ${Colors.white};
  }

  @media (min-width: 380px) {
    width: 164px;
  }

  @media (min-width: 420px) {
    width: 188px;
  }

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    width: 100%;
    height: 98px;
  }

  @media (min-width: ${Styleguide.breakpoints.desktop}) {
    width: 240px;
    padding: 0px 24px;
  }

  .logo {
    width: 100px;
    align-self: center;
  }
`;

export const ContainerProvider = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
`;

export const ProviderImage = styled.img`
  display: block;
  margin: auto auto;
  width: 100%;
`;
